<template>
  <v-dialog v-model="dialog" :fullscreen="isMobile" :hide-overlay="isMobile" width="40%">
    <v-card class="pa-5">
      <v-container class="pa-0 d-flex justify-space-between mb-6">
        <v-card-text class="pa-0 text-body-1">{{
          $t("editProductInformation")
        }}</v-card-text>
        <v-icon size="17" style="cursor: pointer" @click="dialog = false">
          mdi-close
        </v-icon>
      </v-container>
      <v-row v-if="product" class="pa-0 ma-0 gap-5 wrapper-numpad-dialog">
        <v-col class="pa-0 ma-0">
          <v-container class="pa-0 d-flex align-center gap-2">
            <img
              :src="
                product.product?.avatar?.link || require('@/assets/imagePlacholder.png')
              "
              class="product-img"
            />
            <div>
              <v-card-text class="pa-0 text-body-2">{{
                product.product?.name
              }}</v-card-text>
              <v-card-text class="pa-0 text-caption" style="color: #858585">
                {{
                  product.product?.code ? $t("code") + ": " + product.product?.code : ""
                }}
              </v-card-text>
            </div>
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-1 mt-4">
            <v-btn
              outlined
              color="primary"
              height="33"
              style="max-width: 33px; min-width: 33px"
              @click="emitInsertCountByPlus(product)"
            >
              <v-icon size="17">mdi-plus</v-icon>
            </v-btn>
            <div class="flex-grow-1">
              <v-text-field
                v-model="product.count"
                v-disabled-icon-focus
                height="28"
                outlined
                class="inpt-count"
                min="0"
                hide-details
                :rules="[(v) => !!v || $t('is-required')]"
                :placeholder="$t('count')"
                type="number"
                style="flex: none"
                @blur="$emit('zeroCountCheck', product)"
                @input="emitInsertCount(product)"
                @focus="insertNumpad('count', product)"
                :autofocus="true"
              />
            </div>
            <v-btn
              outlined
              color="error"
              height="33"
              :disabled="product.count == 0"
              style="max-width: 33px; min-width: 33px"
              @click="emitInsertByMinus(product)"
            >
              <v-icon size="18">mdi-minus</v-icon>
            </v-btn>
          </v-container>
          <v-container class="pa-0 mt-4">
            <v-text-field
              v-model="product.product.barcode"
              :label="$t('barcode')"
              height="20"
              dense
              outlined
              clearable
              @focus="insertNumpad('barcode')"
              @input="insertNumpad('barcode')"
            />
          </v-container>
          <v-container class="pa-0 mt-8">
            <money
              ref="refMoney"
              v-model="product.fee"
              :label="$t('fee')"
              :outlined="true"
              :clearable="true"
              @focus="insertNumpad('fee')"
              @input="insertNumpad('fee')"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-4">
            <div>
              <v-text-field
                v-model="product.discountPercent"
                :label="$t('discountPercent')"
                height="20"
                class="inpt-dt"
                type="number"
                min="0"
                max="100"
                outlined
                clearable
                @focus="insertNumpad('discountPercent')"
                @input="insertNumpad('discountPercent')"
              />
            </div>
            <div class="flex-grow-1">
              <money
                v-model="discountAmount"
                :label="$t('discount-amount')"
                :outlined="true"
                @focus="insertNumpad('discountAmount')"
                @input="insertNumpad('discountAmount')"
              />
            </div>
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-4">
            <div>
              <v-text-field
                v-model="product.tax_percent"
                :label="$t('taxPercent')"
                height="20"
                class="w-100 inpt-dt"
                type="number"
                :disabled="selectedTaxOption == 'deactive'"
                outlined
                clearable
                @focus="insertNumpad('taxPercent')"
                @input="insertNumpad('taxPercent')"
              />
            </div>
            <div class="flex-grow-1">
              <money
                v-model="taxAmount"
                :label="$t('tax-amount')"
                :disabled="selectedTaxOption == 'deactive'"
                :outlined="true"
                :readonly="true"
              />
            </div>
          </v-container>
          <v-container class="pa-0 mt-4">
            <money
              v-model="productSum"
              :label="$t('sum')"
              :outlined="true"
              :readonly="true"
            />
          </v-container>
        </v-col>
        <v-col class="pa-0 ma-0">
          <div class="overflow-y-auto ma-1 mx-0 mt-0">
            <numpad
              :input="numpadValue"
              :label="numpadLable"
              :needSeperator="needSeperator"
              @save="setNumpad"
            />
          </div>
        </v-col>
      </v-row>
      <v-container
        class="pa-0 d-flex justify-space-between align-center pt-3 mt-3"
        style="border-top: 1px solid silver"
      >
        <v-btn
          color="primary"
          height="38"
          v-shortkey="['shift', 'f1']"
          @shortkey="updateArticle"
          @click="updateArticle"
        >
          {{ $t("confirm") }} (shift+f1)
        </v-btn>
        <v-spacer />
        <v-btn
          v-shortkey="['shift', 'f2']"
          @shortkey="update"
          color="primary"
          outlined
          height="38"
          :loading="loading"
          @click="update"
        >
          {{ $t("updateProductAndChangeArticle") }} (shift+f2)
        </v-btn>
      </v-container>
    </v-card>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import General from "@/Mixins/general";

export default {
  name: "ProductDialog",
  components: {
    numpad: () => import("../../../components/general/numpad/index.vue"),
  },
  mixins: [General],
  model: { prop: "value", event: "input" },
  props: ["value", "item", "decimal", "selectedTaxOption"],
  data() {
    return {
      loading: false,
      numpadLable: null,
      numpadValue: null,
      product: null,
      productSum: null,
      selectedInput: null,
      rowDiscountInputSource: null,
      discountAmount: null,
      taxAmount: null,
      updatingFromDiscount: false,
      productFee: null,
      productCount: null,
      productBarcode: null,
      productDiscountPercent: null,
      productTaxPercent: null,
      needSeperator: true,
    };
  },
  computed: {
    dialog: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  watch: {
    item: {
      handler(val) {
        if (!val) return;
        // insert data for watching them
        this.productCount = val.count;
        this.productBarcode = val.product.barcode;
        this.productFee = val.fee;
        this.productDiscountPercent = val.discountPercent;
        this.productTaxPercent = val.tax_percent;
        //check val wiith product
        if (val !== this.product) {
          this.updatingFromDiscount = false;
          this.rowDiscountInputSource = null;
        }

        if (!this.updatingFromDiscount) {
          this.product = val;

          let fee = val.fee;
          let count = val.count;
          // let discountPercent = val.discountPercent / 100;
          let total = parseFloat(fee || 0) * parseFloat(count || 0);
          // let discount = total * discountPercent;
          this.clampRowDiscount();
          let discount = parseFloat(this.product.discount || 0);
          this.discountAmount = discount;
          let taxPercent = val.tax_percent / 100;
          let tax = (total - discount) * taxPercent;
          this.taxAmount = tax;

          if (this.selectedTaxOption == "active") {
            this.productSum = (
              parseFloat(total || 0) -
              parseFloat(discount || 0) +
              parseFloat(isNaN(tax) ? 0 : tax)
            ).toFixed(this.decimal);
          } else {
            this.productSum = (
              parseFloat(total || 0) - parseFloat(discount || 0)
            ).toFixed(this.decimal);
          }
        }

        val.product.price = val.fee;
        // console.log(val)
      },
      deep: true,
    },
    updatingFromDiscount(val) {
      // console.log(val)
    },
    discountAmount: {
      handler(val) {
        if (val !== null && val !== undefined && val !== "") {
          this.rowDiscountInputSource = "amount";
          this.updatingFromDiscount = true;
          // update discout (percent + amount)
          // this.product.discount = val;
          // this.product.discountPercent = parseFloat(
          //   (
          //     (Number(val) / (Number(this.product.fee) * Number(this.product.count))) *
          //     100
          //   ).toFixed(2)
          // );
          const rowMax =
            parseFloat(this.product.fee || 0) * parseFloat(this.product.count || 0);
          let discount = Math.min(rowMax, Math.max(0, parseFloat(val) || 0));
          this.product.discount = discount;
          this.discountAmount = discount;
          this.product.discountPercent =
            rowMax > 0 ? parseFloat((discount / rowMax) * 100) : 0;
          if (this.product.discountPercent > 100) {
            this.product.discountPercent = 100;
          }
          // update tax (amount + percent) + productSum
          let fee = this.product.fee;
          let count = this.product.count;
          let total = parseFloat(fee || 0) * parseFloat(count || 0);
          let taxPercent = this.product.tax_percent / 100;
          let tax = (total - this.product.discount) * taxPercent;
          this.taxAmount = tax;

          if (this.selectedTaxOption == "active") {
            this.productSum = (
              parseFloat(total || 0) -
              parseFloat(this.product.discount || 0) +
              parseFloat(isNaN(tax) ? 0 : tax)
            ).toFixed(this.decimal);
          } else {
            this.productSum = (
              parseFloat(total || 0) - parseFloat(this.product.discount || 0)
            ).toFixed(this.decimal);
          }
        }
      },
      deep: true,
    },
    productFee: {
      handler(val) {
        if (val) {
          this.updatingFromDiscount = false;
        }
      },
      deep: true,
    },
    productCount: {
      handler(val) {
        if (val) {
          this.updatingFromDiscount = false;
        }
      },
      deep: true,
    },
    productBarcode: {
      handler(val) {
        if (val) {
          this.updatingFromDiscount = false;
        }
      },
      deep: true,
    },
    productDiscountPercent: {
      handler(val) {
        if (val) {
          this.updatingFromDiscount = false;
        }
      },
      deep: true,
    },
    productTaxPercent: {
      handler(val) {
        if (val) {
          this.updatingFromDiscount = false;
        }
      },
      deep: true,
    },
    selectedTaxOption: {
      handler(val) {
        if (this.product) {
          let fee = this.product.fee;
          let count = this.product.count;
          let total = parseFloat(fee || 0) * parseFloat(count || 0);
          let taxPercent = this.product.tax_percent / 100;
          let tax = (total - this.product.discount) * taxPercent;
          this.taxAmount = tax;

          if (val == "active") {
            this.productSum = (
              parseFloat(total || 0) -
              parseFloat(this.product.discount || 0) +
              parseFloat(isNaN(tax) ? 0 : tax)
            ).toFixed(this.decimal);
          } else {
            this.productSum = (
              parseFloat(total || 0) - parseFloat(this.product.discount || 0)
            ).toFixed(this.decimal);
          }
        }
      },
      deep: true,
    },
    dialog(val) {
      if (val) {
        // this.$refs.refMoney.setFocus()
      }
      this.$emit("input", val);
    },
    value(val) {
      if (!val) {
        this.$store.commit("SET_PREINPUT", null);
      }
    },
  },
  mounted() {
    // window.addEventListener('focusin', this.focusOff)
  },
  methods: {
    getRowDiscountMax() {
      if (!this.product) return 0;
      return parseFloat(this.product.fee || 0) * parseFloat(this.product.count || 0);
    },
    clampRowDiscount() {
      if (!this.product) return;
      const rowMax = this.getRowDiscountMax();
      const preferPercent = this.rowDiscountInputSource === "percent";
      let percent = parseFloat(this.product.discountPercent);
      if (isNaN(percent) || percent < 0) percent = 0;
      if (percent > 100) percent = 100;
      let discount = parseFloat(this.product.discount);
      if (isNaN(discount) || discount < 0) discount = 0;
      if (rowMax <= 0) {
        percent = 0;
        discount = 0;
      } else if (discount > rowMax) {
        discount = rowMax;
        percent = 100;
      } else if (preferPercent && percent > 0) {
        discount = parseFloat((rowMax * (percent / 100)).toFixed(this.decimal));
      } else if (discount > 0) {
        discount = Math.min(rowMax, discount);
        percent = parseFloat((discount / rowMax) * 100);
        if (percent > 100) {
          percent = 100;
          discount = rowMax;
        }
      } else if (percent > 0) {
        discount = parseFloat((rowMax * (percent / 100)).toFixed(this.decimal));
      }
      this.product.discountPercent = percent;
      this.product.discount = discount;
      this.discountAmount = discount;
    },
    // focusOff () {
    //   if (!this.$store.state.autoFocus) {
    //     var preInput = this.$store.state.preInput
    //     var element = window.document.activeElement
    //     if (element.tagName.toLowerCase() === 'input') {
    //       if (element.autofocus && !preInput) {
    //         this.$store.commit('SET_PREINPUT', element)
    //       }
    //     } else {
    //       if (preInput && !element.classList.contains('notranslate')) {
    //         setTimeout(function () {
    //           preInput.focus()
    //         }, 100)
    //       } else {
    //         this.$store.commit('SET_PREINPUT', null)
    //       }
    //     }
    //   }
    // },
    insertNumpad(type, product) {
      this.numpadLable = this.$t(type);
      this.selectedInput = type;
      this.needSeperator = true;

      if (type === "count" && product) {
        this.numpadValue = this.product.count;
        this.needSeperator = false;
        if (product.count == 0) {
          return null;
        } else {
          return product.count;
        }
      }
      if (type === "fee") {
        this.numpadValue = this.product.fee;
      }
      if (type === "discountPercent") {
        this.rowDiscountInputSource = "percent";
        this.numpadValue = this.product.discountPercent;
        const raw = String(this.product.discountPercent);
        const num = parseFloat(raw);
        if (
          raw == "-" ||
          raw == "+" ||
          this.product.discountPercent == "-" ||
          this.product.discountPercent == "+" ||
          raw.includes("-") ||
          raw.includes("+") ||
          isNaN(num) ||
          num < 0 ||
          num > 100
        ) {
          this.product.discountPercent = 0;
        }
        this.clampRowDiscount();
      }
      if (type === "discountAmount") {
        this.rowDiscountInputSource = "amount";
        this.numpadValue = this.discountAmount;
      }
      if (type === "taxPercent") {
        this.numpadValue = this.product.tax_percent;
      }
      if (type === "barcode") {
        this.numpadValue = this.product.product.barcode;
        this.needSeperator = false;
      }
    },
    setNumpad(data) {
      if (this.selectedInput === "count") {
        this.product.count = data;
      }
      if (this.selectedInput === "fee") {
        this.product.fee = data;
      }
      if (this.selectedInput === "discountPercent") {
        this.rowDiscountInputSource = "percent";
        this.product.discountPercent = data;
        this.clampRowDiscount();
      }
      if (this.selectedInput === "discountAmount") {
        this.rowDiscountInputSource = "amount";
        this.discountAmount = data;
        this.clampRowDiscount();
      }
      if (this.selectedInput === "taxPercent") {
        this.product.tax_percent = data;
      }
      if (this.selectedInput === "barcode") {
        if (this.product && this.product.product.barcode == undefined) {
          this.$set(this.product.product, "barcode", data);
        } else {
          this.product.product.barcode = data;
        }
      }
    },
    update() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            updateProduct: "active",
            product: app.product.product,
          },
        })
        .then((res) => {
          res = res.data;
          app.updateOffline();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    updateOffline() {
      if (
        parseFloat(this.product.fee) === 0 ||
        !this.product.fee ||
        this.product.fee === ""
      ) {
        this.snakbarText = this.$t("pleasEnterPrice");
        this.snakbarColor = "pink";
        this.snakbar = true;
        return false;
      }
      var isDB = localStorage.getItem("dbCreated");
      if (isDB) {
        this.DBCreate();
      }
      if (isDB && isDB === "active") {
        this.loading = true;
        this.loadingDialog = true;
        var app = this;
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + this.$store.state.userId);
        connection
          .update({
            in: "products",
            set: {
              barcode: app.product.product.barcode,
              price: app.product.fee,
              tax_percent: app.product.tax_percent,
              discount_percent: app.product.discountPercent,
            },
            where: {
              id: app.product.product.id,
            },
          })
          .then(function (results) {});
        connection
          .update({
            in: "productShortcutItems",
            set: {
              barcode: app.product.product.barcode,
              price: app.product.fee,
              tax_percent: app.product.tax_percent,
              discount_percent: app.product.discountPercent,
            },
            where: {
              id: app.product.product.id,
            },
          })
          .then(function (results) {
            app.clampRowDiscount();
            app.$emit("setItem", app.product);
            app.dialog = false;
          });
      }
    },
    updateArticle() {
      if (
        parseFloat(this.product.fee) === 0 ||
        !this.product.fee ||
        this.product.fee === ""
      ) {
        this.snakbarText = this.$t("pleasEnterPrice");
        this.snakbarColor = "pink";
        this.snakbar = true;
        return false;
      }
      this.clampRowDiscount();
      this.$emit("setItem", this.product);
      this.dialog = false;
    },
    emitInsertCount(product) {
      if (this.product.count < 0) {
        this.product.count = 0;
      } else {
        this.$emit("checkCount", product);
        this.numpadValue = this.product.count;
      }
    },
    emitInsertCountByPlus(product) {
      this.$emit("addCount", product);
      this.numpadValue = this.product.count;
    },
    emitInsertByMinus(product) {
      this.$emit("minusCount", product);
      this.numpadValue = this.product.count;
    },
  },
};
</script>

<style scoped>
.product-img {
  width: 50px;
  height: 50px;
  border: 1px solid #c0c0c063;
  border-radius: 4px;
}
::v-deep .v-text-field--enclosed .v-input__append-inner,
::v-deep
  .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
  .v-input__append-inner {
  margin-top: 5px;
}
::v-deep .v-text-field--outlined .v-label.v-label--active {
  top: 17px;
}
::v-deep .v-text-field--outlined .v-label {
  top: 7px;
}
.inpt-dt ::v-deep .v-input__control .v-input__slot {
  width: 110px;
}
.wrapper-numpad-dialog ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}
.wrapper-numpad-dialog ::v-deep .v-text-field__details {
  display: none;
}
</style>
